import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';
import { EJsonQueryPriceType } from '../../../packages/api-models/common/json_query';

export const selectCommercialPriceType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermValue('price_type')(jsonQuery) as EJsonQueryPriceType | null,
);
